class AnnouncementBarAnchor extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.handleAnchorLinks();
  }

  handleAnchorLinks() {
    const links = this.querySelectorAll('a[href^="#"]');

    links.forEach((link) => {
      link.addEventListener('click', (e) => {
        const href = link.getAttribute('href');
        const targetId = href.substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          e.preventDefault();

          const headerHeight = this.getHeaderHeight();
          const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth',
          });
        }
      });
    });
  }

  getHeaderHeight() {
    const header = document.querySelector('.section-header');
    if (header) {
      return header.offsetHeight;
    }
    return 0;
  }
}

customElements.define('announcement-bar-anchor', AnnouncementBarAnchor);
